import React, { useState } from 'react';
import '../../styles/quiz-base.css';
import './altura.css';
import Footer from '../../components/footer/Footer';

const API_BASE = process.env.REACT_APP_API_BASE;

const Altura = ({ onSucesso }) => {
  const [altura, setAltura] = useState('');
  const [erro, setErro] = useState('');
  const [enviando, setEnviando] = useState(false);

  const handleChange = (e) => {
    setAltura(e.target.value);
    setErro('');
  };

  const handleEnviar = async () => {
    const alturaNum = parseInt(altura);
    if (isNaN(alturaNum) || alturaNum < 100 || alturaNum > 250) {
      setErro('Digite sua altura entre 100 e 250 cm');
      return;
    }

    setEnviando(true);

    try {
      const resposta = await fetch(`${API_BASE}/salvar-etapa.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          campo: 'altura_cm',
          valor: alturaNum
        })
      });

      const dados = await resposta.json();

      if (dados.status === 'sucesso') {
        onSucesso(); // Avança para a próxima etapa
      } else {
        setErro(dados.mensagem || 'Erro ao salvar. Tente novamente.');
      }
    } catch (error) {
      setErro('Erro de conexão com o servidor.');
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="quiz-etapa">
      <img src="/assets/logo1.png" alt="Logo NutriFitMe" className="quiz-logo" />

      <div className="quiz-progresso">
        <div className="quiz-progresso-barra">
          <div className="quiz-progresso-preenchido" style={{ width: '28.5%' }}></div>
        </div>
        <div className="quiz-progresso-texto">3 de 7</div>
      </div>

      <h2 className="quiz-pergunta">Qual a sua altura?</h2>
      <p className="quiz-texto-extra">Informe em centímetros (ex: 170 = 1,70m).</p>

      <input
        type="number"
        className="quiz-input"
        placeholder="Ex: 170"
        value={altura}
        onChange={handleChange}
        min="100"
        max="250"
      />

      {erro && <p className="quiz-erro">{erro}</p>}

      <button
        className={`quiz-botao ${altura && !enviando ? 'ativo' : ''}`}
        onClick={handleEnviar}
        disabled={!altura || enviando}
      >
        {enviando ? 'Enviando...' : 'Continuar'}
      </button>

      <div className="quiz-footer">
        <Footer />
      </div>
    </div>
  );
};

export default Altura;
